/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Add_CaptionInputs */

const en_story_add_caption = /** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a caption... (optional)`)
};

const es_story_add_caption = /** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir una leyenda... (opcional)`)
};

const fr_story_add_caption = /** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une légende... (facultatif)`)
};

const de_story_add_caption = /** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschrift hinzufügen... (optional)`)
};

const id_story_add_caption = /** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan keterangan... (opsional)`)
};

/** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */
const ja_story_add_caption = en_story_add_caption;

/** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */
const zh_story_add_caption = en_story_add_caption;

/** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */
const ar_story_add_caption = en_story_add_caption;

/** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */
const it_story_add_caption = en_story_add_caption;

/** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */
const ru_story_add_caption = en_story_add_caption;

/** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */
const pt_story_add_caption = en_story_add_caption;

/** @type {(inputs: Story_Add_CaptionInputs) => LocalizedString} */
const ko_story_add_caption = en_story_add_caption;

/**
* | output |
* | --- |
* | "Add a caption... (optional)" |
*
* @param {Story_Add_CaptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_add_caption = /** @type {((inputs?: Story_Add_CaptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Add_CaptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_add_caption(inputs)
	if (locale === "es") return es_story_add_caption(inputs)
	if (locale === "fr") return fr_story_add_caption(inputs)
	if (locale === "de") return de_story_add_caption(inputs)
	if (locale === "ja") return ja_story_add_caption(inputs)
	if (locale === "zh") return zh_story_add_caption(inputs)
	if (locale === "ar") return ar_story_add_caption(inputs)
	if (locale === "id") return id_story_add_caption(inputs)
	if (locale === "it") return it_story_add_caption(inputs)
	if (locale === "ru") return ru_story_add_caption(inputs)
	if (locale === "pt") return pt_story_add_caption(inputs)
	return ko_story_add_caption(inputs)
});